import * as bodyPix from '@tensorflow-models/body-pix';
import '@tensorflow/tfjs';

export const removeBackground = async (file) => {
  const img = document.createElement('img');
  img.src = URL.createObjectURL(file);

  await new Promise((resolve) => {
    img.onload = resolve;
  });

  const net = await bodyPix.load();

  const segmentation = await net.segmentPerson(img);

  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;

  const ctx = canvas.getContext('2d');

  ctx.drawImage(img, 0, 0);

  const imageData = ctx.getImageData(
    0,
    0,
    canvas.width,
    canvas.height
  );

  const data = imageData.data;

  for (let i = 0; i < segmentation.data.length; i++) {
    if (segmentation.data[i] === 0) {
      data[i * 4 + 3] = 0;
    }
  }

  ctx.putImageData(imageData, 0, 0);

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(
        new File([blob], 'removed-bg.png', {
          type: 'image/png'
        })
      );
    }, 'image/png');
  });
};